export default "__VITE_ASSET__DacdFNnj__"